import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "required" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = { class: "d-flex align-items-center mt-3" }
const _hoisted_37 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_38 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_39 = { class: "form-check form-check-inline form-check-solid" }
const _hoisted_40 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = { class: "row mb-6" }
const _hoisted_44 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_45 = { class: "col-lg-8 fv-row" }
const _hoisted_46 = { class: "d-flex align-items-center mt-3" }
const _hoisted_47 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_48 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_49 = { class: "form-check form-check-inline form-check-solid" }
const _hoisted_50 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "col-lg-8 fv-row" }
const _hoisted_56 = { class: "d-flex flex-column align-items-start mt-3" }
const _hoisted_57 = { class: "form-check form-check form-check-solid me-5" }
const _hoisted_58 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_59 = { class: "form-check form-check form-check-solid mt-2" }
const _hoisted_60 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_61 = { class: "form-check form-check form-check-solid mt-2" }
const _hoisted_62 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_66 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_account_profile_details_submit",
  class: "btn btn-dark-blue"
}
const _hoisted_67 = { class: "indicator-label" }
const _hoisted_68 = { class: "indicator-progress" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_add_company_setting_modal = _resolveComponent("add-company-setting-modal")!

  return (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
    (_ctx.selectLists)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate("CHANGE_AZIENDA_SETTINGS_MAIN_HEADER")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              id: "kt_account_profile_details_form",
              class: "form",
              novalidate: "novalidate",
              onSubmit: _ctx.updateCompanyProfile,
              "validation-schema": _ctx.profileDetailsValidator
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.translate("AZIENDA_DENOM_STRING")), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "denom",
                        class: "form-control form-control-lg",
                        placeholder: "Company name",
                        modelValue: _ctx.companyProfile.denom,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyProfile.denom) = $event)),
                        "aria-label": _ctx.translate('AZIENDA_DENOM_STRING')
                      }, null, 8, ["modelValue", "aria-label"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "denom" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translate("AZIENDA_SECTOR_STRING")), 1),
                      _cache[12] || (_cache[12] = _createElementVNode("i", {
                        class: "fas fa-exclamation-circle ms-1 fs-7",
                        "data-bs-toggle": "tooltip",
                        title: "Industrial sector must be active"
                      }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "settore",
                        class: "form-select form-select-solid form-select-lg",
                        modelValue: _ctx.companyYearlyParams.azienda_yearly_parameters.settore,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyYearlyParams.azienda_yearly_parameters.settore) = $event)),
                        "aria-label": _ctx.translate('AZIENDA_SECTOR_STRING')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.settori, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.id,
                              key: index
                            }, [
                              _createElementVNode("b", null, _toDisplayString(item[_ctx.translateKey("descrizione")]), 1)
                            ], 8, _hoisted_16))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "aria-label"]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_ErrorMessage, { name: "settore" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.translate("AZIENDA_REVENUE_STRING")), 1),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "fatturato",
                        class: "form-select form-select-solid form-select-lg",
                        modelValue: _ctx.companyYearlyParams.azienda_yearly_parameters.fatturato,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyYearlyParams.azienda_yearly_parameters.fatturato) = $event)),
                        "aria-label": _ctx.translate('AZIENDA_REVENUE_STRING')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.fatturati, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.id,
                              key: index
                            }, [
                              (_ctx.locale === 'it')
                                ? (_openBlock(), _createElementBlock("b", _hoisted_23, _toDisplayString(item.descrizione), 1))
                                : (_openBlock(), _createElementBlock("b", _hoisted_24, _toDisplayString(item.descrizione_en), 1))
                            ], 8, _hoisted_22))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "aria-label"]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_ErrorMessage, { name: "fatturato" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.translate("AZIENDA_EMPLOYEES_RANGE_STRING")), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "employees_range",
                        class: "form-select form-select-solid form-select-lg",
                        modelValue: _ctx.companyYearlyParams.azienda_yearly_parameters.employees_range,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyYearlyParams.azienda_yearly_parameters.employees_range) = $event)),
                        "aria-label": _ctx.translate('AZIENDA_EMPLOYEES_RANGE_STRING')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.employee_range, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.range_id,
                              key: index
                            }, [
                              _createElementVNode("b", null, _toDisplayString(item.description), 1)
                            ], 8, _hoisted_30))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "aria-label"]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_ErrorMessage, { name: "employees_range" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.translate("AZIENDA_IS_ASSOCIATED_STRING")), 1),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("label", _hoisted_37, [
                          _createVNode(_component_Field, {
                            type: "radio",
                            class: "form-check-input",
                            name: "is_associated",
                            value: 1,
                            modelValue: _ctx.companyYearlyParams.azienda_yearly_parameters.is_associated,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyYearlyParams.azienda_yearly_parameters.is_associated) = $event)),
                            "aria-label": _ctx.translate('CHANGE_ASSOCIATED_OPTION')
                          }, null, 8, ["modelValue", "aria-label"]),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.translate("CHANGE_ASSOCIATED_OPTION")), 1)
                        ]),
                        _createElementVNode("label", _hoisted_39, [
                          _createVNode(_component_Field, {
                            type: "radio",
                            class: "form-check-input",
                            name: "is_associated",
                            value: 0,
                            modelValue: _ctx.companyYearlyParams.azienda_yearly_parameters.is_associated,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyYearlyParams.azienda_yearly_parameters.is_associated) = $event)),
                            "aria-label": _ctx.translate('CHANGE_NOT_ASSOCIATED_OPTION')
                          }, null, 8, ["modelValue", "aria-label"]),
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.translate("CHANGE_NOT_ASSOCIATED_OPTION")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_ErrorMessage, { name: "is_associated" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.translate("AZIENDA_IS_QUOTED_STRING")), 1),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("label", _hoisted_47, [
                          _createVNode(_component_Field, {
                            type: "radio",
                            class: "form-check-input",
                            name: "is_quoted",
                            value: 1,
                            modelValue: _ctx.companyYearlyParams.azienda_yearly_parameters.is_quoted,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyYearlyParams.azienda_yearly_parameters.is_quoted) = $event)),
                            "aria-label": _ctx.translate('CHANGE_QUOTED_OPTION')
                          }, null, 8, ["modelValue", "aria-label"]),
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.translate("CHANGE_QUOTED_OPTION")), 1)
                        ]),
                        _createElementVNode("label", _hoisted_49, [
                          _createVNode(_component_Field, {
                            type: "radio",
                            class: "form-check-input",
                            name: "is_quoted",
                            value: 0,
                            modelValue: _ctx.companyYearlyParams.azienda_yearly_parameters.is_quoted,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.companyYearlyParams.azienda_yearly_parameters.is_quoted) = $event)),
                            "aria-label": _ctx.translate('CHANGE_NOT_QUOTED_OPTION')
                          }, null, 8, ["modelValue", "aria-label"]),
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.translate("CHANGE_NOT_QUOTED_OPTION")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_ErrorMessage, { name: "is_quoted" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.translate("AZIENDA_COMPANY_TYPE_STRING")), 1),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("label", _hoisted_57, [
                          _createVNode(_component_Field, {
                            type: "radio",
                            class: "form-check-input",
                            name: "company_type",
                            value: "D01",
                            modelValue: _ctx.companyYearlyParams.azienda_yearly_parameters.company_type,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.companyYearlyParams.azienda_yearly_parameters.company_type) = $event)),
                            "aria-label": _ctx.translate('CHANGE_PMI_OPTION')
                          }, null, 8, ["modelValue", "aria-label"]),
                          _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.translate("CHANGE_PMI_OPTION")), 1)
                        ]),
                        _createElementVNode("label", _hoisted_59, [
                          _createVNode(_component_Field, {
                            type: "radio",
                            class: "form-check-input",
                            name: "company_type",
                            value: "D02",
                            modelValue: _ctx.companyYearlyParams.azienda_yearly_parameters.company_type,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.companyYearlyParams.azienda_yearly_parameters.company_type) = $event)),
                            "aria-label": _ctx.translate('CHANGE_SMALL_OPTION')
                          }, null, 8, ["modelValue", "aria-label"]),
                          _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.translate("CHANGE_SMALL_OPTION")), 1)
                        ]),
                        _createElementVNode("label", _hoisted_61, [
                          _createVNode(_component_Field, {
                            name: "company_type",
                            type: "radio",
                            class: "form-check-input",
                            value: "D03",
                            modelValue: _ctx.companyYearlyParams.azienda_yearly_parameters.company_type,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.companyYearlyParams.azienda_yearly_parameters.company_type) = $event)),
                            "aria-label": _ctx.translate('CHANGE_LARGE_OPTION')
                          }, null, 8, ["modelValue", "aria-label"]),
                          _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.translate("CHANGE_LARGE_OPTION")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createVNode(_component_ErrorMessage, { name: "company_type" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onResetFields && _ctx.onResetFields(...args))),
                    class: "btn fw-bold btn-outline"
                  }, _toDisplayString(_ctx.translate("BUTTON_DISCARD_CHANGES")), 1),
                  _createElementVNode("button", _hoisted_66, [
                    _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.translate("BUTTON_SAVE_CHANGES")), 1),
                    _createElementVNode("span", _hoisted_68, [
                      _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_add_company_setting_modal, { ref: "addCompanySettingModalRef" }, null, 512)
  ]))
}